/**
 * v0.17.16: what to tell the user after a project create that carried renewal
 * details. The backend saves the project first and the renewal permit second;
 * when the second step fails it returns permit_created=false plus a
 * renewal_warning. Before this, the failure was only logged and the renewal
 * was lost without anyone knowing.
 */
export const RENEWAL_NOT_SAVED_FALLBACK =
  'The project was saved but its renewal was not. Add it on the Permits page.';

export function renewalNotSavedMessage(
  sentRenewal: boolean,
  result: { permit_created?: boolean; renewal_warning?: string | null } | null | undefined
): string | null {
  if (!sentRenewal) return null;
  if (result?.permit_created) return null;
  return result?.renewal_warning || RENEWAL_NOT_SAVED_FALLBACK;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2027-07-30" -> "Jul 30, 2027". Read as a calendar date (no time zone
 *  shift). Anything else is returned unchanged. */
export function formatExpiryDate(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return value;
  const month = MONTHS[Number(m[2]) - 1];
  return month ? `${month} ${Number(m[3])}, ${m[1]}` : value;
}

/** v0.17.16: some renewal detail was filled in but the expiry date was not.
 *  Without an expiry date no renewal is sent, so block the create instead of
 *  dropping what she typed. */
export function renewalNeedsExpiry(fields: {
  expiryDate: string;
  permitTypeDefinitionId: string;
  recurringPeriod: string;
}): boolean {
  return !fields.expiryDate && !!(fields.permitTypeDefinitionId || fields.recurringPeriod);
}
